import React from 'react';
import CityLayout from '../../components/CityLayout';
import '../../styles/index.scss';

const Esbjerg = () => <CityLayout city="Esbjerg" />;

export default Esbjerg;
